import React, { useState } from "react";
import "./LearnerRegistration.css";
import { useTheme } from "../../context/ThemeContext";
import Card from "../../components/Card";
import { RxCrossCircled } from "react-icons/rx";
import { learnerRegistration } from "../../api/api";

const LearnerRegistration = ({ registrationView, learnerAdded }) => {
    const { themeStyles } = useTheme();

    // Form states
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [prn, setPrn] = useState("");
    const [parentNumber, setParentNumber] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [batch, setBatch] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [dob, setDob] = useState("");

    // Form submission handler
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form reload
        setError(""); // Clear previous errors
        setSuccess(""); // Clear previous success messages

        // Check required fields
        if (!name || !password || !batch || !dob || !prn || !parentNumber) {
            setError("All required fields must be filled!");
            return;
        }

        if (password !== confirmPassword) {
            setError("Password and Confirm Password should be same!");
            return;
        }

        // Payload for API
        const learnerDetails = {
            name: name + " " + lastName,
            password,
            batch,
            email,
            dob,
            prn,
            phoneNumber,
            parentNumber
        };

        try {
            const response = await learnerRegistration(learnerDetails);
            setSuccess(response.message || "Learner registered successfully!");
            // Reset form
            setName("");
            setPassword("");
            setBatch("");
            setEmail("");
            setParentNumber("");
            setPhoneNumber("");
            learnerAdded();
        } catch (err) {
            setError(
                err || err.response?.data?.message || "An error occurred during registration."
            );
        }
    };

    return (
        <Card>
            <form
                className="learner-form"
                style={{
                    color: themeStyles.text,
                    position: 'relative'
                }}
                onSubmit={handleSubmit}
            >

                <button onClick={registrationView} style={{ position: 'absolute', right: 0, top: -10 }}>
                    <RxCrossCircled color={themeStyles.text} size={22} />
                </button>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="name">First Name*</label>
                        <input
                            type="text"
                            id="firstName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter learner's First name"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="name">Last Name*</label>
                        <input
                            type="text"
                            id="lastName"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            placeholder="Enter learner's Last name"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="batch">Batch*</label>
                        <select
                            className="w-full py-2 border rounded-md focus:outline-none focus:ring-2"
                            style={{
                                backgroundColor: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                borderColor: themeStyles.text,
                                height: "65%"

                            }}
                            onChange={(e) => { if (e.target.value !== "select") setBatch(e.target.value) }}
                        >
                            <option value="select">Select Batch</option>
                            <option value="BCS-I">BCS-I</option>
                            <option value="BSC-II">BSC-II</option>
                            <option value="BSC-III">BSC-III</option>
                        </select>
                        {/* <input
                            type="text"
                            id="batch"
                            value={batch}
                            onChange={(e) => setBatch(e.target.value)}
                            placeholder="Enter batch"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        /> */}
                    </div>
                    <div className="form-group">
                        <label htmlFor="batch">Date of Birth*</label>
                        <input
                            type="date"
                            id="dob"
                            value={dob}
                            onChange={(e) => setDob(e.target.value)}
                            placeholder="Enter Date of Birth"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                </div>

                <div className="form-row">
                    {/* Email */}
                    <div className="form-group">
                        <label htmlFor="email">PRN*</label>
                        <input
                            type="text"
                            id="prn"
                            value={prn}
                            onChange={(e) => setPrn(e.target.value)}
                            placeholder="Enter PRN number"
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>

                    {/* Phone Number */}
                    <div className="form-group">
                        <label htmlFor="phoneNumber">Parent Phone Number*</label>
                        <input
                            type="tel"
                            id="parentNumber"
                            value={parentNumber}
                            onChange={(e) => setParentNumber(e.target.value)}
                            placeholder="Enter Parent Phone Number"
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                </div>

                <div className="form-row">
                    {/* Email */}
                    <div className="form-group">
                        <label htmlFor="email">Email*</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter email"
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>

                    {/* Phone Number */}
                    <div className="form-group">
                        <label htmlFor="phoneNumber">Phone Number*</label>
                        <input
                            type="tel"
                            id="phoneNumber"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            placeholder="Enter phone number"
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                </div>

                <div className="form-row">
                    {/* Password */}
                    <div className="form-group">
                        <label htmlFor="password">Password*</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter Password"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>

                    {/* Confirm Password */}
                    <div className="form-group">
                        <label htmlFor="password">Confirm Password*</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Enter Confirm Password"
                            required
                            style={{
                                background: themeStyles.cardContentBackground,
                                color: themeStyles.text,
                                border: `1px solid ${themeStyles.text}`,
                            }}
                        />
                    </div>
                </div>

                {/* Error and Success Messages */}
                {error && <p className="error-message">{error}</p>}
                {success && <p className="success-message">{success}</p>}

                <div className="card-footer">
                    {/* Settings Button */}

                    {/* Generate Questions Button */}
                    <button className="card-button center bg-custom-blue">
                        Register Learner
                    </button>
                </div>
            </form>
        </Card>
    );
};

export default LearnerRegistration;
